import { Outlet, useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import styled, { createGlobalStyle } from "styled-components";
import Logo from "@/assets/icons/Logo";
import FoxLogo from "@/assets/icons/FoxLogo";
import Sidebar from "@/components/Sidebar";
import { useGetSideList } from "@/components/Sidebar/constant/SideList";
import { useSwitchSidebar } from "@/components/Sidebar/hooks/useSwitchSidebar";
import GiftIcon from "@/assets/icons/topup/gift";
import routerUtil from "@/utils/routerUtil";
import { UserProfile } from "@/components/RenderbusLayout/components/user-profile";
import { AuthStatusTip } from "@/components/RenderbusLayout/components/auth-status-tip";
import { useGlobalStore } from "@/store/GlobalStore";
import { useTranslation } from "react-i18next";
import { useLotteryHeader } from "./hooks/useLotteryHeader";
import { useState, useEffect } from "react";
import BellIcon from "@/assets/icons/profile/bell";
import ServiceActivedIcon from "@/assets/icons/profile/service-actived";
import ServiceFoxActivedIcon from "@/assets/icons/profile/service-fox-actived";

import { IconButtonWrapper, Layout, RedRadio, LogoWrap } from "./atom";
import DropdownIcon from "@/assets/icons/profile/drop-down";
import { MenuItem } from "./config/service-menu";
import { isDev } from "project-config/utils/env";
import { useLocation } from "react-router-dom";
import { HumanService } from "@renderbus/widgets/components/human-service";
import { useScaleOutside } from "project-config/hooks/useScaleOutside";
import { Toast } from "task-eva-ui";
import { useToastStore } from "@/store/toast-store";
import request from "project-config/services/request/request";
import { MessageDropdown } from "@renderbus/widgets/components/message-dropdown";
import { host } from "project-config/utils/env";
import { AuthenticateModal } from "./components/authenticate-modal";
import { PlatformNoticeModal } from "./components/platform-notice-modal";
import { useTaskSocket } from "./hooks/use-task-socket";
import { saleSmartlyInstance } from "project-config/services";
import { LotteryModal } from "./components/lottery-modal";

const { Header, Content, Sider } = Layout;

const LayoutStyle = createGlobalStyle`
  .ant-layout-header {
    box-shadow: 4px 4px 10px rgba(1, 8, 12, 0.6) !important;
    z-index: 1;
  }
`;

const ServiceDropdownStyle = createGlobalStyle`
  .service-dropdown {
    .ant-dropdown-menu {
      padding: 0;
      background: #17181C;
      border: 1px solid #4F5053;
      border-radius: 2px;
      min-width: 166px;
      width: max-content;
    }
    .ant-dropdown-menu-item {
      min-height: 42px;
      padding: 0 13px;
      &:last-child {
        ${MenuItem} {
          border: unset;
        }
      }
    }
  }
`;

const RenderbusHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 48px;
  a {
    color: #13cb75;
  }
`;

const RenderbusContentLayout = styled(Layout)`
  min-height: calc(100vh - 48px);
`;

const RenderbusSider = styled(Sider)`
  min-height: calc(100vh - 48px);
  background: #262729 !important;
`;

const HeaderButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
`;

export const HeaderItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  &.renderbus-header--bill {
    border: 1px solid #f2f3f5;
  }
  &.renderbus-header--profile {
    background: var(--main-color);
  }
`;

const RenderbusContent = styled(Content)<{ isfullscreen: boolean }>`
  margin: ${(p) => (p.isfullscreen ? 0 : "16px 24px 0")};
  min-height: max-content;
`;

const HeaderSliderLogo = styled.div`
  display: flex;
  align-items: center;
  line-height: initial;
  span {
    font-weight: 600;
    color: #ffffff;
    &::before {
      content: "";
      border: 1px solid #43454d;
      margin: 0 16px;
    }
  }
`;

const HeaderItemActivity = styled.div`
  background: linear-gradient(98.16deg, #fd6a4a 2.09%, #f0271a 98.11%);
  border-radius: 4px;
  height: 24px;
  margin-top: 14px;
  margin-bottom: 10px;
  margin-right: 24px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    height: 38px;
    width: 38px;
    position: absolute;
    top: -14px;
  }
  span {
    padding-left: 44px;
    font-weight: 600;
    font-size: 12px;
    padding-bottom: 2px;
    padding-right: 12px;
  }
`;

// const OrangeRadio = styled.div`
//   width: 8px;
//   height: 8px;
//   border-radius: 50%;
//   background: #ffc266;
//   position: absolute;
//   left: 12px;
//   top: -1px;
// `;

export default function RenderbusLayout() {
  const [currentHover, setCurrentHover] = useState("");
  routerUtil.navigate = useNavigate();
  const sideList = useGetSideList();
  const location = useLocation();
  const { pathname, switchSidebar } = useSwitchSidebar();
  const {
    isDomestic,
    userInfo,
    isSubAccount,
    isPictureUser,
    isFullScreen,
    isClientOrigin,
    isZh,
  } = useGlobalStore();
  const baseUrl = isDev() ? "https://task-pre" : "https://task";
  const host1 = isDomestic ? ".renderbus.com" : ".foxrenderfarm.com";
  const { toastProps, updateGlobalToast } = useToastStore();
  const { showLotteryHeader } = useLotteryHeader();
  const { t } = useTranslation("center");
  const currentSubTitle = t(
    pathname === "/topUp" ? "user_payment_center_title" : "user_center_title"
  );
  const [openLotteryModal, setOpenLotteryModal] = useState(false);
  const [fiveMessageList, setFiveMessageList] = useState([]);
  const [unRenderMessage, setUnRenderMessage] = useState(0);
  const [unRead, setUnRead] = useState(0);
  function handleHover(key: string) {
    setCurrentHover(key);
  }
  useEffect(() => {
    if (
      !location.search
        .substr(1)
        .match(new RegExp("(^|&)openCashPrize=true([^&]*)(&|$)", "i"))
    )
      return;
    showLotteryHeader && setOpenLotteryModal(true);
  }, [location.search, showLotteryHeader]);

  useEffect(() => {
    // 监听消息
    if (userInfo?.userId) {
      saleSmartlyInstance.onUnRead(setUnRead);
    }
  }, [userInfo?.userId]);

  const getMessagegList = async () => {
    const { data, code } = await request.post(
      "/api/rendering/message/messagegList",
      {
        pageNum: 1,
        pageSize: 5,
      }
    );
    if (code === 200 && data) {
      setFiveMessageList(data.items);
    } else {
      setFiveMessageList([]);
    }
  };

  const getMessageStatic = async () => {
    const { data, code } = await request.get(
      "/api/rendering/message/messageStatistics"
    );
    if (code === 200) {
      setUnRenderMessage(data.notRead);
    }
  };

  useEffect(() => {
    if (!userInfo) return;
    void getMessagegList();
    void getMessageStatic();
  }, [userInfo, location]);

  useScaleOutside(isClientOrigin);
  useTaskSocket();

  if (!pathname) return null;
  return (
    <Layout>
      {!isFullScreen && (
        <RenderbusHeader>
          <HeaderSliderLogo>
            <a href={host}>
              {isDomestic ? (
                <LogoWrap>
                  {" "}
                  <Logo />
                </LogoWrap>
              ) : (
                <FoxLogo />
              )}
            </a>
            <span>{currentSubTitle}</span>
          </HeaderSliderLogo>

          <HeaderButtonGroup>
            {showLotteryHeader && !isSubAccount && (
              <HeaderItemActivity onClick={() => setOpenLotteryModal(true)}>
                <GiftIcon />
                <span>{t("user_recharge_raffle")}</span>
              </HeaderItemActivity>
            )}
            <Dropdown
              overlayClassName={"service-dropdown"}
              dropdownRender={() => (
                <MessageDropdown
                  fiveMessageList={fiveMessageList}
                  isZh={isZh}
                  isDomestic={isDomestic}
                />
              )}
            >
              <IconButtonWrapper
                onClick={() =>
                  window.open(`${baseUrl}${host1}/message/center`, "_blank")
                }
                onMouseOver={() => handleHover("bell")}
                onMouseOut={() => handleHover("")}
              >
                <BellIcon active={currentHover === "bell"} />
                {unRenderMessage > 0 && <RedRadio />}
                <span>{t("message_task_content")}</span>
              </IconButtonWrapper>
            </Dropdown>
            <Dropdown
              overlayClassName={"service-dropdown"}
              dropdownRender={() => (
                <HumanService
                  salesmanEmail={userInfo?.salesmanEmail}
                  salesmanName={userInfo?.salesmanName}
                  salesmanPhone={userInfo?.salesmanPhone}
                  isPictureUser={isPictureUser}
                  isDomestic={isDomestic}
                  unRead={unRead}
                />
              )}
            >
              <IconButtonWrapper
                onMouseOver={() => handleHover("service")}
                onMouseOut={() => handleHover("")}
              >
                <div className="message-icon">
                  {isDomestic ? (
                    <ServiceActivedIcon />
                  ) : (
                    <ServiceFoxActivedIcon />
                  )}
                  {/* {!isDomestic && unRead > 0 && <OrangeRadio />} */}
                </div>
                <span style={{ color: isDomestic ? "#21DC9E" : "#FC7032" }}>
                  {t("header_button_service")}
                </span>
                <DropdownIcon />
              </IconButtonWrapper>
            </Dropdown>
            <ServiceDropdownStyle />
            <IconButtonWrapper>
              <UserProfile />
              <HeaderItem className="renderbus-header--profile">
                <div>{userInfo?.userName?.[0].toUpperCase()}</div>
              </HeaderItem>
              <span>{userInfo?.userName}</span>
              <DropdownIcon />
            </IconButtonWrapper>
          </HeaderButtonGroup>
        </RenderbusHeader>
      )}
      <RenderbusContentLayout>
        {pathname !== "/topUp" && !isFullScreen && (
          <RenderbusSider>
            <Sidebar
              sideList={sideList}
              activePath={pathname}
              onChange={switchSidebar}
            />
          </RenderbusSider>
        )}
        <Layout>
          <AuthStatusTip />

          <RenderbusContent isfullscreen={!!isFullScreen}>
            <Outlet />
          </RenderbusContent>
        </Layout>
      </RenderbusContentLayout>
      <LotteryModal
        openLotteryModal={openLotteryModal}
        onClose={() => setOpenLotteryModal(false)}
      />
      <AuthenticateModal />
      <LayoutStyle />
      <Toast {...toastProps} setShow={updateGlobalToast} />
      <PlatformNoticeModal />
    </Layout>
  );
}
